import { motion } from 'framer-motion';
import styled from 'styled-components';

import { GradientHeader, Text } from '@/components/design-system';
import { ANIMATIONS } from '@/utils';

const Wrapper = styled.div`
  margin: 112px 0 64px 0;
  padding: 0 56px;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    margin: 88px 0 48px 0;
    align-self: flex-start;
  }
`;

const H2 = styled(GradientHeader)`
  text-align: center;
  max-width: 600px;
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    text-align: left !important;
    max-width: none;
    margin: 0 0 24px 0;
  }
`;

const Subheading = styled(Text)`
  text-align: center;
  max-width: 750px;
  margin: 24px auto 0 auto;

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    text-align: left;
  }
`;

interface HeadingProps {
  heading?: string;
  subheading?: string;
}

export function Heading(props: HeadingProps) {
  return (
    <Wrapper {...ANIMATIONS.SimpleFadeIn} as={motion.div}>
      {props.heading && <H2 renderAs="h2">{props.heading}</H2>}
      {props.subheading && (
        <Subheading size="extra-large">{props.subheading}</Subheading>
      )}
    </Wrapper>
  );
}
